import { Component, inject, input } from '@angular/core';
import { OfferDocument } from '../../models/offers.model';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';

@Component({
    selector: 'app-offer-document',
    templateUrl: './offer-document.component.html',
    styleUrl: './offer-document.component.scss',
    standalone: false
})
export class OfferDocumentComponent {
  readonly document = input.required<OfferDocument>();
  readonly baseurl = input.required<string>();

  private readonly dataLayerService = inject(DataLayerService);

  sendViewDocumentEvent(documentName: string): void {
    this.dataLayerService.addtoDataLayer('viewDocument_OfferEvent', { document_name: documentName });
  }

  sendDownloadDocumentEvent(documentName: string): void {
    this.dataLayerService.addtoDataLayer('downloadDocument_OfferEvent', { document_name: documentName });
  }

}
